// Dependencies
import axios from 'axios'
import Cookies from 'js-cookie'

export const leadsApi = axios.create({
  baseURL: `${process.env.REACT_LEADS_API_URL}`
})

leadsApi.interceptors.request.use(
  (request) => {
    const authCookie = Cookies.get('authData')

    if (authCookie) {
      const applicationToken = `Bearer ${authCookie}`
      request.headers.Authorization = applicationToken
    }

    return request
  },
  (error) => Promise.reject(error)
)
